import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDidMount, useStateWithCallback } from "../../utils/hooks";
import { numToPrice, pexios, toast } from '../../utils/functions';
import Pagination from "../../components/master/Pagination";
import allPrice01 from '../../assets/images/all-price01.png';
import distance01 from '../../assets/images/distance01.png';
import penelty01 from '../../assets/images/penelty01.png';
import allPrice02 from '../../assets/images/all-price02.png';
import distance02 from '../../assets/images/distance02.png';
import balance from '../../assets/images/balance.png';
import gift from '../../assets/images/gift.png';
import giftBox from "../../assets/images/giftBox.png";
import Reduction from "../../assets/images/recession.png"
import { useSelector } from 'react-redux';
import { history, url } from '../../utils/variables';
import { useTranslation } from 'react-i18next';
import DatePicker from '../../components/master/DatePicker';
import Credit from '../../assets/images/icons/ballon-credit.png'
import Salary from '../../assets/images/icons/wage.png'
import DistanceLocation from '../../assets/images/icons/distance.png'
import Files from '../../assets/images/icons/experted-files.png'

export default function Wallet() {

    const user = useSelector(store=> store.user)
    const [logs, setLogs] = useState([]);
    const [wallet, setWallet] = useState({});
    const [currentPage, setCurrentPage] = useStateWithCallback(1);
    const [lastPage, setLastPage] = useState(1);
    const [loader, setLoader] = useState(false);
    const { t } = useTranslation();
    // const {setTitle} = useContext(TitleContext);
    const [searchDate , setSearchDate] = useState({
        from :'',
        to: ''
    })
    const [searchResult,setSearchResult] = useState([]);
    const [noResult,setNoResult] = useState(false);
    function changeSearchDate(value,type) {
        setSearchDate(prevState=>({
            ...prevState,
            [type]: value
        }))
    }

    const getWallet = useCallback(() => {
        pexios('/api/v2/get_wallet').then(res => {
            setWallet(res.data.data);
        });
    }, []);

    useDidMount(() => {
        getWallet();
        loadLogs();
    });

    function loadLogs(page = 1) {
        setLoader(true);
        // pexios(`/api/v2/get_wallet_logs?page=${page}`)
        pexios(`/api/v2/get_wallet_logs`,'post',{page:page,start:searchDate.from,end:searchDate.to})
            .then(res => {
                const result = res.data;
                setLoader(false);
                setLogs(result.data);
                setLastPage(result?.meta?.last_page||1);
            });
    }
    // function requestPay() {
    //     setLoader(true);
    //     pexios('/api/request_pay').then(()=>{
    //         setLoader(false);
    //         getWallet();
    //     });
    // }
    function changePage(page) {
        setCurrentPage(page, (currentPage) => loadLogs(currentPage));
    }
    function getDetails() {
        if(!searchDate.from || !searchDate.to) {
            toast('لطفا تاریخ شروع و پایان را مشخص نمایید','error')
            return;
        }
        pexios(`/api/v2/get_wallet_details`,'post',{start:searchDate.from,end:searchDate.to})
            .then(res => {
                const result = res.data;
                setLoader(false);
                setSearchResult(result);
                result.length > 0 ? setNoResult(false) : setNoResult(true)
            });
        loadLogs()
    }

    return (
        <div className='content wallet'>
            {
                user.type !== 'expert' &&
                <>
                <div className='d-flex flex-column box-header mt20 p10 b-bl-sharp' 
                // style={{border: '2px solid rgb(29, 209, 161)',borderRadius: '10px'}}
                >
                    <div className='p5 text-right' style={{fontSize: '14px'}}>
                        {t('Balance of digital wallet')}:<span style={user.my_wallet?.total_left < 0 ? {color: 'red'} : {}}>{numToPrice(user.my_wallet?.total_left || 0)} {t('rial')} </span>
                        <div className='payment-btn mt10 text-left'>
                            <button className='btn btn-orange btn-circle' style={{fontSize: '11px'}} onClick={()=>history.replace('/payment')}>{t('Inventory increase')}<i className='fas fa-plus pl5' style={{color : 'white',fontSize: '12px'}}/></button>
                        </div>
                    </div>
                </div>
                </>
                // :
                // <div className='glass-modal'>
                //     <p>ما با قدرت و علاقه در حال بروزرسانی خدمات این صفحه هستیم و به  زودی در دسترس شما قرار خواهد گرفت .</p>
                //     <p>ممنون از صبوریتون !</p>
                // </div>

                
            //    <>
            // <div className='walletBox' style={{border: '3px solid #1dd1a1'}}>
            //     <h5 className="title text-center border-bottom pb5">{t('Cleared')}</h5>
            //     <div className='walletWrapper'>
            //         <img src={allPrice01} alt=""/>
            //         <p>{t('Total price')} :{wallet.total_pay && wallet.total_pay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
            //     </div>
            //     <div className='walletWrapper'>
            //         <img src={gift} alt=""/>
            //         <p>{t('Gift')} : {wallet.total_gift && wallet.total_gift.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
            //     </div>
            //     <div className='walletWrapper'>
            //         <img src={penelty01} alt=""/>
            //         <p>{t('Penalty')} : {wallet.total_penalty && wallet.total_penalty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
            //     </div>
            //     <div className='walletWrapper'>
            //         <img src={distance01} alt=""/>
            //         <p>{t('Distance')} : {wallet.dis_pay && wallet.dis_pay.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('Kilometr')}</p>
            //     </div>
            // </div>
            // <div className='walletBox mt20' style={{border: '3px solid #ddb038'}}>
            //     <h5 className="title text-center border-bottom pb5">{t('Current Account')}</h5>
            //     <div className='walletWrapper'>
            //         <img src={allPrice02} alt=""/>
            //         <p> {t('Fees')} :{wallet.total_left && (wallet.total_left - wallet.penalty_left).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
            //     </div>
            //     <div className='walletWrapper'>
            //         <img src={Reduction} alt=""/>
            //         <p> {t('Legal deductions')} :<span style={{color : 'red'}}>{wallet.total_left && ((wallet.total_left + (wallet.dis_left * wallet.transportation))*.1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}-</span> {t('rial')}</p>
            //     </div>
            //     <div className='walletWrapper'>
            //         <img src={balance} alt=""/>
            //         <p>{t('Balance of financial performance')}:{wallet.penalty_left && wallet.penalty_left.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('rial')}</p>
            //     </div>
            //     <div className='walletWrapper'>
            //         <img src={distance02} alt=""/>
            //         <p>{t('Distance')} : {wallet.dis_left && wallet.dis_left.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} {t('Kilometr')}</p>
            //     </div>
            // </div>
            // <div className='final-price'>
            //     <img src={allPrice02} alt=""/>
            //     <p>{t('Due price')}:<span style={{fontWeight : 'bold'}}>{wallet.total_left && ((wallet.total_left + (wallet.dis_left * wallet.transportation))*.9).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span> {t('rial')}</p>
            // </div>
            // </>
            }
            {user.type === 'expert' && 
            <div className='expert-wallet'>
                    <div className='wallet-logs'>
                        <div className='log'>  
                            <div className='d-flex align-items-start'>
                                <div className='d-flex flex-column mr10'>
                                    <p className='log-title'>اعتبار حساب در بالن</p>
                                    <small className='subtitle align-self-end mr5'>(ریال)</small>
                                </div>
                                <div className='log-icon'>
                                    <img src={Credit}/>
                                </div>
                            </div>
                            <p className='log-value mt5'>{numToPrice(wallet.wallet_charge)}</p>
                        </div>
                        <div className='log'>
                            <div className='d-flex align-items-start'>
                                <p className='log-title mr10'>کارشناسی های انجام شده</p>
                                <div className='log-icon'>
                                    <img src={Files}/>
                                </div>
                            </div>
                            <p className='log-value mt5'>{wallet.count_left}</p>
                        </div>
                        <div className='log'>
                            <div className='d-flex align-items-start'>
                            <div className='d-flex flex-column mr10'>
                                <p className='log-title'> مبلغ کل کارکرد در بالن</p>
                                <small className='subtitle align-self-end mr5'>(ریال)</small>
                            </div>
                            <div className='log-icon'>
                                <img src={Salary}/>
                            </div>
                            </div>
                            <p className='log-value mt5'>{numToPrice(wallet.total_left)}</p>
                        </div>
                        <div className='log'>
                            <div className='d-flex align-items-start'>
                                <div className='d-flex flex-column mr10'>
                                    <p className='log-title'>مسافت طی شده</p>
                                    <small className='subtitle align-self-end mr5'>(کیلومتر)</small>
                                </div>
                                <div className='log-icon'>
                                    <img src={DistanceLocation}/>
                                </div>
                            </div>
                            <p className='log-value mt5'>{numToPrice(wallet.dis_left)}</p>
                        </div>
                    </div>
                    <p className='title text-center border-bottom m10 p10'>جستجو بر اساس تاریخ</p>
                    <div className='date-search text-right'>
                        <div className='date from'>
                            <DatePicker
                                label='تاریخ شروع'
                                value={searchDate['from']}
                                onChange={(value)=> changeSearchDate(value,'from')}
                            />
                        </div>
                        <div className='date to'>
                        <DatePicker
                            label='تاریخ پایان'
                            rtl
                            value={searchDate['to']}
                            onChange={(value)=> changeSearchDate(value,'to')}
                        />
                        </div>
                        <button className='btn btn-orange search-btn' onClick={getDetails}>جستجو</button>
                    </div>
                    {searchResult.length > 0 &&

                        searchResult.map(l=>(
                            <div className='search-result mt20 p10'>
                        {/* <div className='result-header'>نتایج جستجو</div> */}

                        <div className='res-box'>
                        <div className='img-insu'>
                            {/* <img src={`${url}/images/insurances/avatar/code/13.png`}/> */}
                            <img src={`${url}/images/insurances/avatar/code/${l.company_id}.png`}/>
                        </div>
                        <div className='d-flex flex-column flex1 mx5'>
                        <div className='res-col border-bottom'>
                            <p className='res-title'>تعداد پرونده ها</p>
                            {/* <p className='res-value'>5</p> */}
                            <p className='res-value'>{l.count}</p>
                        </div>
                        <div className='res-col border-bottom mt5'>
                            <p className='res-title'>مبلغ کل کارکرد <small>(ریال)</small></p>
                            {/* <p className='res-value'>{numToPrice(25698)}</p> */}
                            <p className='res-value'>{numToPrice(l.total_expert_value)}</p>
                        </div>
                        <div className='res-col mt5'>
                            <p className='res-title'>کارمزد بالن <small>(ریال)</small></p>
                            {/* <p className='res-value'>{numToPrice(1234455)}</p> */}
                            <p className='res-value'>{numToPrice(l.total_balloon_value)}</p>
                        </div>
                        </div>
                            
                        </div>
                    </div>
                        ))
                    }
                    {noResult &&
                        <p className='no-result-text'>نتیجه ای در این بازه زمانی یافت نشد</p>
                    }
                </div>
            }
        {user.type === 'expert' && !noResult &&
            <div
                className='text-center'
            >
                <p className='title text-center border-bottom m20 p10'>{t('Transaction list')}</p>
                <ul>
                    {
                        loader ?
                            <i className='fa fa-spinner fa-spin' /> :
                            logs.map((log, index) =>
                                log.content.includes(t('Price charge')) ?
                                    <li style={{backgroundColor: '#b2ebbc'}} key={index}>{log.content.split(" به پول کیف کارشناس "+user.full_name).join('')}</li> :
                                    log.content.includes(t('Checkout')) ?
                                    <li style={{backgroundColor: '#96d5f1'}} key={index}>{log.content}</li> :
                                        log.content.includes(t('Gift')) ?
                                        <li style={{backgroundColor: '#faf68f'}} key={index}>{log.content}</li> :
                                            log.content.includes(t('ََAward')) ?
                                            <div className='gift-box' key={index}>
                                                <img src={giftBox} alt="giftImage"/>
                                                <li className="wallet-gift"><i className='fas fa-gift pl10 ' style={{fontSize:"16px", color:"#ed03e6"}}/>{log.content}</li>
                                            </div>:
                                            <li style={{backgroundColor: '#ff7575'}} key={index}>{log.content}</li>
                            )
                    }
                </ul>
                <div className='mt20'>
                    <Pagination
                        currentPage={currentPage}
                        total={lastPage}
                        changePage={changePage}
                    />
                </div>
            </div>
        }
        </div>
    );
}
